module.exports = __webpack_public_path__ + "static/media/remove-icon.6dc98c71.svg";